import { Entity } from '@toggle/toggle';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { useQueryParams } from '~/hooks/use-query-params/useQueryParams';
import { queryKeys } from '~/routes/app-paths';

import { CompetitorsTab } from './components/competitors-tab/CompetitorsTab';
import { ThemeExposureTab } from './components/theme-exposure-tab/ThemeExposureTab';
import * as S from './KnowledgeGraphWidget.styles';

export enum KnowledgeGraphTabType {
  ThemeExposure = 'themeExposure',
  Competitors = 'competitors',
}

interface KnowledgeGraphWidgetProps {
  entity: Entity;
}

export const KnowledgeGraphWidget = ({ entity }: KnowledgeGraphWidgetProps) => {
  const { t } = useTranslation(['widget']);
  const { params, setQueryParams } = useQueryParams();

  const knowledgeGraphTabs = [
    {
      tabLabel: t('assetOverview.knowledgeGraph.subtab.themeExposure'),
      tabType: KnowledgeGraphTabType.ThemeExposure,
    },
    {
      tabLabel: t('assetOverview.knowledgeGraph.subtab.competitors'),
      tabType: KnowledgeGraphTabType.Competitors,
    },
  ];

  const renderTabContent = (tab: KnowledgeGraphTabType) => {
    if (tab === KnowledgeGraphTabType.Competitors) {
      return <CompetitorsTab entity={entity} />;
    }

    return <ThemeExposureTab entity={entity} />;
  };

  const onTabChange = (tab: KnowledgeGraphTabType) => {
    setQueryParams({ [queryKeys.activeSubTab]: tab });
  };

  const activeTab = params[queryKeys.activeSubTab]
    ? (params[queryKeys.activeSubTab] as KnowledgeGraphTabType)
    : KnowledgeGraphTabType.ThemeExposure;

  return (
    <S.Container>
      <S.StyledButtonGroup
        labels={knowledgeGraphTabs.map(t => t.tabLabel)}
        activeIndex={activeTab === KnowledgeGraphTabType.ThemeExposure ? 0 : 1}
        onClick={tab => onTabChange(knowledgeGraphTabs[tab].tabType)}
      />
      {renderTabContent(activeTab)}
    </S.Container>
  );
};
